import { inject } from "@angular/core";

import { NotificationService } from "../notification/services/notification.service";
import { ICheckChangesComponent } from "./interfaces/check-changes-component";
import { FormUtil } from "./form-util";
import {
    CanDeactivateFn, MaybeAsync
} from "@angular/router";

/**
 * CanDeactivate Guard which checks the component for changes, and will prompt the user to confirm discarding changes before
 * leaving the route
 * @returns true if the user can deactivate, false otherwise. Can possibly be an observable.
 */
export const checkChangesCanDeactivate: CanDeactivateFn<ICheckChangesComponent> = (component: ICheckChangesComponent):
MaybeAsync<boolean> => {

    const notificationService = inject(NotificationService);
    if (!component) {
        return true;
    }
    return FormUtil.handleFormLeave$(component, notificationService);
};
